import React from "react";

const LeftShadow = ({ className = "absolute inset-0" }) => (
  <div
    aria-hidden="true"
    className={`pointer-events-none bg-gradient-to-r from-black via-transparent to-transparent ${className}`}
  />
);

export default LeftShadow;
